import React, { FC, useContext, useEffect, useState } from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors, Stats, useSearch } from "@usereactify/search";
import { ProntoProvider } from "../providers/pronto"
import { Results } from "./Results/results";
import { useSearchArticles } from "../hooks/useSearchArticles";

const SearchPage = () => {
  const { searchTerm, setSearchTerm, submitSearchTerm } = useSearch();
  const handleSearch = React.useCallback(() => {
    submitSearchTerm(searchTerm);
  }, [submitSearchTerm, searchTerm]);
  const submitSearchKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      handleSearch();
    }
  };
  const searchResults = useSearchArticles();
  const [activeTab, setactiveTab] = useState<"products" | "articles">("products");

  return (
    <ProntoProvider>
      <header className="page-header--wrapper">
        <div className="row{% if full_width %} full-width-row-full{% endif %}">
          <div className="small-12 columns">
            <div className="page-header ">
              <div className="page-header__inner">
                <h1 className="thb-shop-title">Search Results</h1>
                <form role="search" method="get" className="searchform" action="">
                  <fieldset>
                    <input
                      type="search"
                      className="search-field"
                      placeholder="Search for anything"
                      name="q"
                      onKeyDown={(e) => submitSearchKey(e)}
                      value={searchTerm}
                      onChange={(event) => setSearchTerm(event.target.value)}
                    />
                    <button type="submit" className="thb-search-submit">
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M22.1667 29.9583C26.4699 29.9583 29.9583 26.4699 29.9583 22.1667C29.9583 17.8634 26.4699 14.375 22.1667 14.375C17.8634 14.375 14.375 17.8634 14.375 22.1667C14.375 26.4699 17.8634 29.9583 22.1667 29.9583Z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M32.2503 32.2498L27.667 27.6665"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </fieldset>
                </form>
                <div className="search--categories-container">
                  <div onClick={() => setactiveTab("products")}>
                    <span className={`search-categories ${activeTab === "products" ? "active" : ""}`}>
                      <Stats
                        render={(renderProps) => {
                          const results = renderProps?.resultStats?.numberOfResults;
                          return <>{`Products (${results !== undefined ? results : "0"})`}</>;
                        }}
                      />
                    </span>
                  </div>
                  <div onClick={() => setactiveTab("articles")}>
                    <span className={`search-categories ${activeTab === "articles" ? "active" : ""}`}>{`Article (${searchResults?.resources?.results?.articles?.length || "0"
                      })`}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Results activeTab={activeTab} />
    </ProntoProvider>
  );
};

if (window.location.pathname.startsWith("/search")) {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    mode: "search",
    shopifyPermanentDomain: "salt-and-pepper-au.myshopify.com",
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();

  ReactDOM.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <Sensors />
        <SearchPage />
      </ReactifySearchProvider>
    </React.StrictMode>,
    ReactifySearchMountNode
  );
}
